import { DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import {
  SaveButton,
  TextInput,
  SimpleForm,
  useDataProvider,
  useNotify,
  NumberInput,
  useRefresh,
  useTranslate,
} from 'react-admin';

export default function CreateTask({ onClose }: { onClose: () => void }) {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const translate = useTranslate();
  const [saving, setSaving] = useState(false);
  const refresh = useRefresh();
  const onSubmit = async (values: any) => {
    setSaving(true);
    try {
      // 处理嵌套对象，确保数据格式正确
      const processedValues = {
        ...values,
        // 确保 isActive 是布尔值
        isActive: Boolean(values.isActive),
      };

      await dataProvider.create('activity-task-category', { data: processedValues });
      notify(translate('activity.categories.createdSuccessfully'), { type: 'success' });
      refresh();
      onClose();
    } catch (error) {
      console.error('Create error:', error);
      notify(translate('activity.categories.failedToCreate'), { type: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <DialogTitle>{translate('activity.common.createTask')}</DialogTitle>
      <DialogContent>
        <SimpleForm onSubmit={onSubmit} toolbar={<SaveButton alwaysEnable disabled={saving} />}>
          <Stack spacing={2} sx={{ mt: 2 }}>
            <Typography variant="h6">{translate('activity.common.basicInformation')}</Typography>

            <TextInput source="name" label={translate('activity.common.name')} fullWidth required />

            <TextInput source="description" label={translate('activity.common.description')} fullWidth multiline rows={3} />

            <TextInput source="icon" label={translate('activity.common.icon')} fullWidth />

            <NumberInput source="sortOrder" label={translate('activity.common.sortOrder')} fullWidth defaultValue={0} />
          </Stack>
        </SimpleForm>
      </DialogContent>
    </>
  );
}
